import { Onderdeel } from '@auth/marktsegmentBeschikbaarheid';
import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type EnvironmentSettings, type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Risicoscan, {
  onderdeel: Onderdeel.Risicoscan,
  isVisible: (settings: EnvironmentSettings) => {
    const isAdviseurOfIntern = settings.isActiveAdviseur || settings.isInterneGebruiker;

    return settings.nieuweRITOverzichtToggle
      ? isAdviseurOfIntern && settings.heeftRisicoscanPermissie
      : isAdviseurOfIntern;
  },
  create: (settings: EnvironmentSettings): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Risicoscan,
    title: 'Risicoscan',
    url: settings.nieuweRITOverzichtToggle
      ? '/app/aanvraag/risicoscan'
      : '/net/riskinventarisation/',
    iconclass: 'fas fa-wrench',
    target: settings.nieuweRITOverzichtToggle ? '_top' : undefined,
  }),
});
